<template>
  <ul class="userMenu menuWithSubMenu">
    <li>
      <button class="userToggler button borderless" @click="toggle()">
        <IconUser class="iconUser" stroke="1.25" size="20" color="white" />{{ username }}
      </button>
      <ul v-bind:class="{ toggled: toggled }" class="subMenu">
        <li @click="toggleBoth()">
          <router-link :to="{ name: 'usersEdit', params: { id: id } }">Editar Perfil</router-link>
        </li>
        <li><router-link :to="{ name: 'logout' }">Sair</router-link></li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { IconUser } from '@tabler/icons-vue'

export default {
  name: 'SettingsComponent',
  data() {
    return {
      toggled: false,
    }
  },
  components: { IconUser },
  computed: {
    ...mapState({
      activeItem: (state) => state.menuItem.active,
    }),
    username() {
      return this.$store.state.auth.jwt.CustomUserInfo.Name
    },
    id() {
      return this.$store.state.auth.jwt.CustomUserInfo.ID
    },
  },
  methods: {
    toggleMobileMenu() {
      this.$parent.showMobileMenu = !this.$parent.showMobileMenu
    },
    toggleBoth() {
      this.toggleMobileMenu()
      this.toggle()
    },
    toggle() {
      this.toggled = !this.toggled
      if (this.toggled) {
        this.$store.dispatch('menuItem/setActive', 'user')
      }
    },
  },
  watch: {
    activeItem(v) {
      if (v !== 'user') {
        this.toggled = false
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
@use '@/scss/_variables.scss';
@use '@/scss/_navigation.scss';

.userMenu {
  z-index: 1;
}

@media only screen and (min-width: 1000px) {
  .userToggler {
    margin-right: var(--sp);
    margin-top: 0;
    margin-bottom: 0;
    display: flex;
  }
}
.iconUser {
  margin-right: calc(var(--sp) * 0.5);
}
</style>
